import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LoginComponent } from '../components/user/login/login.component';
import { UserComponent } from '../components/user/user.component';

const routes: Routes = [
  {
    path: '',
    component: UserComponent,
    children: [
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full'
      },
      {
        path: 'login',
        component: LoginComponent,
        data: { title: 'Login | BasicStudios' }
      },
      // {
      //   path: 'signup',
      //   component: SignupComponent,
      //   data: { title: 'Signup | BasicStudios' }
      // },
      // {
      //   path: 'signup-completed',
      //   component: SignupCompletedComponent,
      //   data: { title: 'Signup Completed | BasicStudios' }
      // },
      // {
      //   path: 'existing-account',
      //   component: ExistingAccountComponent,
      //   data: { title: 'Existing Account | BasicStudios' }
      // },
      // {
      //   path: 'inactive-account',
      //   component: InactiveAccountComponent,
      //   data: { title: 'Inactive Account | BasicStudios' }
      // },
      // {
      //   path: 'forgot-password',
      //   component: ForgotPasswordComponent,
      //   data: { title: 'Forgot Password | BasicStudios' }
      // },
      // {
      //   path: 'password-reset',
      //   component: PasswordResetComponent,
      //   data: { title: 'Reset Password | BasicStudios' }
      // },
      // {
      //   path: 'homepage',
      //   component: HomepageComponent,
      //   data: { title: 'Welcome | BasicStudios' }
      // },
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
  ]
})
export class UserRouting { }
